import {
  Toast
} from "vant";

export default {
  namespaced: false,
  state: {
    userInfo: {},
    pageInfo: {},
    userToken: '',
    appversion: 0,
    refreshFlag: true
  },
  getters: {
    getUser: state => {
      return state.userInfo
    },
    getToken: state => {
      return state.userToken
    },
    getnativeInfo: state => state.nativeInfo,
    getpageInfo: state => state.pageInfo,
    getAppversion: state => {
      return state.appversion
    },
    getAppversionString: state => {
      return state.appVersionString
    }
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setToken(state, userToken) {
      state.userToken = userToken
    },
    setnativeInfo(state, nativeInfo) {
      state.nativeInfo = nativeInfo
    },
    setpageInfo(state, pageInfo) {
      state.pageInfo = pageInfo
    },
    setAppversion(state, v) {
      state.appversion = v
    },
    setAppversionString(state, v) {
      state.appVersionString = v
    },
    setRefreshFlag(state) {
      state.refreshFlag = false
    }
  },
  actions: {
    initialUserInfo({
      commit
    }) {
      // todo
      if (window.isApp()) {
        window.getUserInfo(function (res) {
          // Toast(res);
          commit('setUserInfo', res)
        })
        // commit('setUserInfo', {})
      }
    }
  }
}